// extracted by mini-css-extract-plugin
export default {"row":"ProductsDashboard_row__PERDC","col":"ProductsDashboard_col__DMdDF","card":"ProductsDashboard_card__r3Z0p"};